import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '../../_shared/tooltip/Tooltip';
import { Epic } from '../providers/epic/Epic';
import { Steam } from '../providers/steam/Steam';
import { useAuth } from '../../authentication/AuthenticationContext';
import { Stadia } from '../providers/stadia/Stadia';
import { useConfig } from '../../ConfigContext';
import { GameIds } from '../my-games/MyGames.model';

import { GameCard } from './game-card/GameCard';

// Import Game Images
import dbdImg from '../../_assets/thumbnail/dbd.webp';
import hoyImg from '../../_assets/thumbnail/hoy.webp';
import mymImg from '../../_assets/thumbnail/mym.webp';
import fmImg from '../../_assets/thumbnail/fm.webp';
import generic from '../../_assets/thumbnail/generic.webp';

import { PageLayout } from '../layout/PageLayout';

// Abstract source img
const gameImg = (id: GameIds): string => {
  switch (id) {
    case GameIds.DBD:
      return dbdImg;
    case GameIds.MYM:
      return mymImg;
    case GameIds.HOY:
      return hoyImg;
    case GameIds.FM:
      return fmImg;
    default:
      return generic;
  }
};

export function MyAccount(): JSX.Element {
  const { t } = useTranslation();
  const auth = useAuth();
  const config = useConfig();
  const newGamesList: string[] = [GameIds.FM, GameIds.MYM];
  return (
    <PageLayout>
      <div className='my-account-container'>
        <h1>{t('button.my-account')}</h1>

        <div className='link-games'>
          <div className='subtitle'>
            <h3>{t('account.my-account.title')}</h3>
            <Tooltip id='tooltip.link' message='tooltip.link' />
          </div>
          <div className='providers-container'>
            {auth.user.authorizedProviders.find(((providerName) => providerName === 'epic'))
            && <Epic />}
            {auth.user.authorizedProviders.find(((providerName) => providerName === 'steam'))
            && <Steam />}
            {auth.user.authorizedProviders.find(((providerName) => providerName === 'stadia'))
            && <Stadia />}
          </div>
        </div>

        <div className='your-games'>
          <h3>{t('account.my-account.games.title')}</h3>

          <div className='games-container'>
            {config?.serverConfig.gamesConfig.map((gameConfig) => (
              <GameCard
                key={`card-${gameConfig.id}`}
                gameConfig={gameConfig}
                isNew={newGamesList.indexOf(gameConfig.id) !== -1}
                gameImage={gameImg(gameConfig.id as GameIds)}
                userPreRegistration={auth.user.preRegistrations[gameConfig.id]}
              />
            ))}
          </div>

        </div>
      </div>
    </PageLayout>
  );
}
